






































































import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData, ReportContext } from '@/utils/ReportUtils';
import PointsOfServiceUtils, {
  PointsOfService,
} from '@/utils/PointsOfServiceUtils';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'deep-equal';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    suborganizationLabel(): string {
      return (
        this.$translate(this.context.survey?.languageobjects?.suborg) ||
        this.$tc('model.survey.suborg')
      );
    },

    suborgsOptions(): any {
      return this.context.suborganizations?.map((suborg: SubOrganization) => ({
        text: this.$translate(suborg.name),
        value: suborg,
      }));
    },
  },

  data(): {
    internal?: Partial<PointsOfService>[];
    pristine?: Partial<PointsOfService>[];
    removeList: Partial<PointsOfService>[];
  } {
    return {
      internal: undefined,
      pristine: undefined,
      removeList: [],
    };
  },

  mounted() {
    this.internal = (this.context.pointsofservices?.map(
      (pointsofservice: PointsOfService) => ({
        ...cloneDeep(pointsofservice),
        suborganizations: pointsofservice.suborganizations?.map((partial) =>
          this.context.suborganizations?.find(
            (suborg: SubOrganization) => partial.id === suborg.id
          )
        ),
      })
    ) || []) as PointsOfService[];
    this.pristine = cloneDeep(this.internal);
  },

  methods: {
    async before() {
      if (!this.context.mode.includes('preview')) {
        const addList: Partial<PointsOfService>[] = [];
        const updateList: Partial<PointsOfService>[] = [];

        this.internal?.forEach((pointsofservice) => {
          if (pointsofservice.id) {
            if (
              !deepEqual(
                pointsofservice,
                this.pristine?.find(
                  (pristine) => pristine.id === pointsofservice.id
                )
              )
            ) {
              updateList.push(pointsofservice); // only set on update if something has changed
            }
          } else {
            addList.push(pointsofservice);
          }
        });

        const resp = await Promise.all([
          addList.length > 0
            ? PointsOfServiceUtils.api.add(addList as PointsOfService[])
            : undefined,
          ...(updateList.map((pointsofservice) =>
            PointsOfServiceUtils.api.update(pointsofservice)
          ) as any[]),
          ...(this.removeList.map((pointsofservice) =>
            PointsOfServiceUtils.api.remove(pointsofservice.id as number)
          ) as any[]),
        ]);
      }

      this.context.pointsofservices = cloneDeep(
        this.internal
      ) as PointsOfService[];
      this.pristine = cloneDeep(this.internal);
    },
    create() {
      this.internal?.push({
        name: this.$languageobj(),
        survey: { id: this.context.survey?.id },
        surveyparticipation: { id: this.context.surveyParticipation?.id },
        question: { id: this.value.item.id },
        suborganizations: [],
      });
      this.handleChange();
    },
    async remove(index: number) {
      if (this.internal) {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [
              this.$translate(this.internal[index].name),
            ])
            .toString(),
          async () => {
            if (this.internal) {
              if (this.internal[index].id) {
                this.removeList.push(this.internal[index]); // if it has an id it must be removed from the server on save
              }
              this.internal?.splice(index, 1);
              this.handleChange();
            }
          }
        );
      }
    },
    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;
        if (this.answer.hasPointsOfService !== undefined) {
          if (
            this.answer.hasPointsOfService === true &&
            this.internal &&
            this.internal.length > 0
          ) {
            completeness++;
          } else if (this.answer.hasPointsOfService === false) {
            completeness++;
          }
        }
        this.value.data.participation.completeness = completeness / 1;
      }
    },
  },
});
